import React from 'react'
import Pagination from '@mui/material/Pagination'
import PropTypes from 'prop-types'

const ListPagination = ({ list = {}, find }) => {
  return list.total > list.limit ? (
    <Pagination
      count={Math.ceil(list.total / list.limit)}
      page={list.skip / list.limit + 1}
      onChange={(__, value) => find({ query: { $skip: (value - 1) * list.limit } })}
    />
  ) : null
}

ListPagination.propTypes = {
  list: PropTypes.object,
  find: PropTypes.func,
}

export default ListPagination
